/* Get Twilio Number */
export const GET_ADMIN_TWILIO_NUMBERS = "GET_ADMIN_TWILIO_NUMBERS"
export const GET_ADMIN_TWILIO_NUMBERS_SUCCESS = "GET_ADMIN_TWILIO_NUMBERS_SUCCESS"
export const GET_ADMIN_TWILIO_NUMBERS_ERROR = "GET_ADMIN_TWILIO_NUMBERS_ERROR"

/* Delete Twilio Number */
export const DELETE_ADMIN_TWILIO_NUMBER = "DELETE_ADMIN_TWILIO_NUMBER"
export const DELETE_ADMIN_TWILIO_NUMBER_SUCCESS = "DELETE_ADMIN_TWILIO_NUMBER_SUCCESS"
export const DELETE_ADMIN_TWILIO_NUMBER_ERROR = "DELETE_ADMIN_TWILIO_NUMBER_ERROR"

/* Export Twilio Numbers */
export const EXPORT_ADMIN_TWILIO_NUMBERS = "EXPORT_ADMIN_TWILIO_NUMBERS"
export const EXPORT_ADMIN_TWILIO_NUMBERS_SUCCESS = "EXPORT_ADMIN_TWILIO_NUMBERS_SUCCESS"
export const EXPORT_ADMIN_TWILIO_NUMBERS_ERROR = "EXPORT_ADMIN_TWILIO_NUMBERS_ERROR"
